module.exports = __webpack_public_path__ + "img/tendle_logo-thumbnail-white.5e2b8298.svg";